import React, { Component, useState, useEffect } from "react";
import { connect } from "react-redux";
import { metadataService, DocumentApi } from "../_services";
import {
    Card,
    CardBody,
    CardHeader,
    Row,
    Col,
    Collapse,
    Alert,
} from "reactstrap";
import {
    SlPageTitle,
    SlBusyIndicator,
    SlInfoIcon,
    SLSvgEmail,
    SLSvgPhone,
} from "./editors";
import { FaRegIdCard, FaFileAlt, FaInfoCircle } from "react-icons/fa";

import { documentActions, profileActions } from "../_actions";
import { loanInfoActions } from "../_actions/loanInfo.actions";
import DocumentUpload from "./DocumentUpload";
import DocumentList from "./subcomponents/DocumentList";
import NotificationModal from "./subcomponents/NotificationModal";


function SecureUpload({ userHash, loadProfile, profileLoaded, ...props }) {
    const [documents, setDocuments] = useState([]);
    const [isBusy, setIsBusy] = useState(false);
    const [notificationModalOpen, setNotificationModalOpen] = useState(false);
    useEffect(() => {
        if (metadataService.isNullOrEmpty(userHash)) {
            loadProfile();
        } else {
            getDocuments();
        }
    }, [userHash])
    const getDocuments = () => {
        setIsBusy(true);
        DocumentApi.getUploadedUserDocuments(userHash).then(response => {
            if (response.data) {
                setDocuments(response.data);
            }
        }).catch((err) => setIsBusy(false))
            .finally(() => setIsBusy(false))
    }
    const onDone = () => {
        setNotificationModalOpen(true);
    }
    const onCloseModal = () => {
        setNotificationModalOpen(false);
        setIsBusy(true);
        setTimeout(() => {
            getDocuments();
        }, 2500);
    } 
    return <React.Fragment>
        <h6 className="mb-3 pb-3 mt-3 pt-3">
            <strong>
                {metadataService.getTitle("DocumentSecureUpload")}
            </strong>
        </h6>
        <p className="mb-0 pb-0">
            {documents.length} {documents.length === 1 ? metadataService.getMessage("DocumentSecureUploadDocument") : metadataService.getMessage("DocumentSecureUploadDocuments")}
        </p >
        <div dangerouslySetInnerHTML={{ __html: metadataService.getMessage("DocumentSecureUpload") }}>
        </div>
        {!metadataService.isNullOrEmpty(userHash) && isBusy !== true && profileLoaded ?
            <React.Fragment>
                <Row>
                    <Col>
                        <DocumentUpload
                            uploadTitle={null}
                            hideTitle={true}
                            hideStatus={true}
                            leadId={null}
                            origin={DocumentApi.DOCUMENT_ORIGIN_UPLOAD}
                            documentStatus={""}
                            documentStatusClass={""}
                            documentClassification={DocumentApi.DOCUMENT_CLASSIFICATION_UNKNOWN}
                            onDone={onDone}
                            hideDropZone={false}
                            lastModified={""}
                            maxAllowedFiles={1}
                            restoreOnDone={true}
                            userHash={userHash}
                        />
                    </Col>
                </Row>
                {documents.length > 0 && (
                    <Row>
                        <Col>
                            <DocumentList
                                dataSource={documents}
                                openFileNewTab={null}
                                leftContent={<FaFileAlt size={60} />}
                            />
                        </Col>
                    </Row>
                )}
            </React.Fragment>
            :
            <Row>
                <Col className={"text-center"}>
                    <SlBusyIndicator visible={true} />
                </Col>
            </Row>}
        <NotificationModal
            open={notificationModalOpen}
            ok={onCloseModal}
            message={metadataService.getMessage("DocumentUploadSuccessful")}
        />
    </React.Fragment>
}

const mapStateToProps = (state) => {
    const { language } = state.users;
    const { userProfile } = state.profile;
    return {
        language,
        userHash: userProfile.userHash,
        profileLoaded: state.profile.profileLoaded,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        loadProfile: () => dispatch(profileActions.loadProfile())
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(SecureUpload);



// WEBPACK FOOTER //
// ./src/components/SecureUpload.jsx